import { useAccount } from '@corratech/pylot-auth-manager'
import { RequestInit } from '@vercel/fetch'
import { SWRConfiguration } from 'swr'
import { Customer, CustomerAddress, Maybe } from '@pylot-data/fwrdschema'
import { GraphQLError } from '@pylot-data/graphqlFetch'

export const useUser = (
    swrOptions: SWRConfiguration = {},
    fetchOptions?: RequestInit
): {
    loading: boolean
    error: GraphQLError
    isSignedIn: boolean
    customer?: Customer
    addresses: Maybe<CustomerAddress>[]
    subscriptionChannels?: Maybe<string>
    getAddressById: (id: number) => Maybe<CustomerAddress>[] | undefined
    getAddressByUid: (uid: string) => Maybe<CustomerAddress>[] | undefined
} => {
    const { data, error, isValidating } = useAccount(swrOptions, fetchOptions)
    const loading = !!(isValidating && !data)
    const isSignedIn = !error && data && !data.errors
    const customer = data?.data?.customer
    const addresses = customer?.addresses || []
    const subscriptionChannels = customer?.subscription_channels

    const getAddressById = (id: number) => {
        return addresses.filter((value) => {
            return value?.id === id
        })
    }

    const getAddressByUid = (uid: string) => {
        return addresses.filter((value) => {
            return value?.uid === uid
        })
    }

    return {
        loading,
        error,
        isSignedIn: !!isSignedIn,
        customer,
        addresses,
        subscriptionChannels: subscriptionChannels,
        getAddressById,
        getAddressByUid
    }
}
